import AnalyticsIncomeByTransfer from '@/views/Report/Analytic/IncomeByTransfer.vue';
import AnalyticsIncomeByTransferItem from '@/views/Report/Analytic/IncomeByTransferItem.vue';
import AnalyticsExpense from '@/views/Report/Analytic/Expense.vue';
import AnalyticsAverageExpense from '@/views/Report/Analytic/AverageExpense.vue';
import AnalyticsIncome from '@/views/Report/Analytic/Income.vue';
import AnalyticsExpenseByTransferItem from '@/views/Report/Analytic/ExpenseByTransferItem.vue';
import AnalyticsTransferDuration from '@/views/Report/Analytic/TransferDuration.vue';
import AnalyticsExpenseByFailedTransfer from '@/views/Report/Analytic/ExpenseByFailedTransfer.vue';

function getComponentFile(name: string) {
  if (name === 'AnalyticsIncomeByTransfer') return AnalyticsIncomeByTransfer;
  if (name === 'AnalyticsIncomeByTransferItem') return AnalyticsIncomeByTransferItem;
  if (name === 'AnalyticsExpense') return AnalyticsExpense;
  if (name === 'AnalyticsAverageExpense') return AnalyticsAverageExpense;
  if (name === 'AnalyticsIncome') return AnalyticsIncome;
  if (name === 'AnalyticsExpenseByTransferItem') return AnalyticsExpenseByTransferItem;
  if (name === 'AnalyticsTransferDuration') return AnalyticsTransferDuration;
  if (name === 'AnalyticsExpenseByFailedTransfer') return AnalyticsExpenseByFailedTransfer;
  return null;
}

export const moduleList = [
  // {
  //   path: 'transfer-duration',
  //   name: 'AnalyticsTransferDuration',
  //   display: 'ระยะเวลาในการจัดส่ง (Lead Time)',
  // },
  // {
  //   path: 'income-by-transfer',
  //   name: 'AnalyticsIncomeByTransfer',
  //   display: 'รายได้ค่าขนส่ง (Revenue)',
  // },
  // {
  //   path: 'income-by-transfer-item',
  //   name: 'AnalyticsIncomeByTransferItem',
  //   display: 'ดัชนีราคา (Price Index)',
  // },
  // {
  //   path: 'expense',
  //   name: 'AnalyticsExpense',
  //   display: 'ต้นทุนค่าขนส่ง (Cost)',
  // },
  // FYI: Hide because TMS-599
  // {
  //   path: 'average-expense',
  //   name: 'AnalyticsAverageExpense',
  //   display: 'ดัชนีต้นทุน (Cost Index)',
  // },
  // {
  //   path: 'income',
  //   name: 'AnalyticsIncome',
  //   display: 'กำไรขั้นต้น และกำไรสุทธิ (%GP, %NP)',
  // },
  // FYI: Hide because TMS-601
  // {
  //   path: 'expense-with-item',
  //   name: 'AnalyticsExpenseByTransferItem',
  //   display: 'ต้นทุนค่าขนส่งต่อมูลค่าสินค้า (%T)',
  // },
  // {
  //   path: 'expense-failed-transfer',
  //   name: 'AnalyticsExpenseByFailedTransfer',
  //   display: 'จัดส่งไม่สำเร็จ (Return / Reject)',
  // },
];

export default moduleList.map((module: any) => ({
  path: module.path,
  name: module.name,
  component: getComponentFile(module.name),
}));
